import { render, staticRenderFns } from "./GovernanceDashboardTab.vue?vue&type=template&id=a716dabc&"
import script from "./GovernanceDashboardTab.vue?vue&type=script&lang=js&"
export * from "./GovernanceDashboardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports